import React from 'react';
import ProductCardQuickSearch from '../ProductCards/ProductCardQuickSearch';
import QuickSearchLinkItem from './QuickSearch.LinkItem';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { cells } from '../../styling/utils/grid';
import { SearchItem } from '../../Types/SearchItem';

interface QuickSearchResultTabProps {
  modelKey: string;
  results: SearchItem[];
}

const QuickSearchResultItem = ({
  modelKey,
  item,
}: {
  modelKey: string;
  item: SearchItem;
}) => {
  switch (modelKey) {
    case 'products':
      return <ProductCardQuickSearch product={item} />;
    default:
      return <QuickSearchLinkItem name={item.name} url={item.url} />;
  }
};

const QuickSearchTab = styled.div`
  margin-top: 2rem;
  gap: 0.8rem !important;
  overflow-y: auto;
  height: calc(100vh - 100px);
  padding-bottom: 14rem;
  grid-auto-rows: min-content;
  ${cells(1)}

  ${breakpoint('medium')} {
    ${cells(2)}
  }
  ${breakpoint('large')} {
    max-height: 256px;
    height: 'unset';
    padding-bottom: 1.6rem;
  }
`;

const QuickSearchResultTab = ({
  modelKey,
  results,
}: QuickSearchResultTabProps) => {
  return (
    <QuickSearchTab id={`quick-search__tab-${modelKey}`} className="grid">
      {results.map((result, index) => (
        <QuickSearchResultItem key={index} modelKey={modelKey} item={result} />
      ))}
    </QuickSearchTab>
  );
};

export default QuickSearchResultTab;
